var __default__ = {root:'m_b183c0a2'};
export default __default__;